<div class="d-flex flex-wrap gap-12 align-items-center p-10 justify-content-between m-b-16">
  <form [formGroup]="ReportForm" class="d-flex flex-wrap gap-12 align-items-center">
    <!-- OPD / Patient search -->
    <mat-form-field appearance="outline" class="filter-field hide-hint">
      <mat-label>{{ 'LABEL.SEARCH_LABEL' | translate }}</mat-label>
      <input matInput [formControl]="patientSearchControl" placeholder="{{ 'LABEL.SEARCH_LABEL' | translate }}" />
      <mat-icon matSuffix>
        <i-tabler name="search" class="icon-20 d-flex m-t-2"></i-tabler>
      </mat-icon>
    </mat-form-field>
    <!-- Doctor Selection -->
    <mat-form-field appearance="outline" class="filter-field hide-hint" *ngIf="!isDoctor">
      <mat-label>{{ 'LABEL.DOCTORS' | translate }}</mat-label>
      <input type="text" matInput placeholder="Search doctors" [formControl]="doctorControls"
        [matAutocomplete]="doctorAuto" />
      <mat-autocomplete #doctorAuto="matAutocomplete">
        <mat-option *ngFor="let doc of filteredDoctorList$ | async" [value]="doc"
          (onSelectionChange)="onDoctorToggle(doc)">
          <mat-checkbox [checked]="isDoctorSelected(doc.id)" (change)="onDoctorToggle(doc)"
            (click)="$event.stopPropagation()">
            {{ doc.name }}
          </mat-checkbox>
        </mat-option>
      </mat-autocomplete>
      <mat-icon matSuffix>
        <i-tabler name="chevron-down" class="icon-18 d-flex m-t-2"></i-tabler>
      </mat-icon>
    </mat-form-field>

    <!-- Date Range Picker -->
    <mat-form-field appearance="outline" class="filter-field hide-hint">
      <mat-label>{{ 'LABEL.DATE_RANGE' | translate }}</mat-label>
      <mat-date-range-input [rangePicker]="rangePicker" [min]="minDate" [max]="maxDate">
        <input matStartDate formControlName="startDate" placeholder="Start date">
        <input matEndDate formControlName="endDate" placeholder="End date">
      </mat-date-range-input>
      <mat-datepicker-toggle matIconSuffix [for]="rangePicker"></mat-datepicker-toggle>
      <mat-date-range-picker #rangePicker></mat-date-range-picker>
    </mat-form-field>

    <!-- Search Button -->
    <button mat-flat-button color="primary" type="button" (click)="OnSearch()" [disabled]="ReportForm.invalid">
      {{ 'BUTTON.BTN_SEARCH' | translate }}
    </button>

    <button mat-stroked-button type="button" (click)="$event.preventDefault(); clearFilters()">
      {{ 'BUTTON.BTN_CLEAR' | translate }}
    </button>
  </form>

  <a mat-icon-button color="primary" (click)="printReport()" *ngIf="isPrintReport" [matTooltip]="'Print Report'">
    <i-tabler name="printer" class="icon-25 d-flex text-primary"></i-tabler>
  </a>

</div>

<mat-card>
  <mat-card-content>
    @if (isLoading) {
    <div class="d-flex justify-content-center p-y-24">
      <mat-spinner diameter="36"></mat-spinner>
    </div>
    } @else {
    <div class="table-responsive table-scroll-container-full">
      <table mat-table [dataSource]="dataSource" class="w-100">
        <ng-container matColumnDef="opdDate">
          <th mat-header-cell *matHeaderCellDef>{{ 'LABEL.OPD_DATE' | translate }}</th>
          <td mat-cell *matCellDef="let row">{{ row.opdDate | date:'dd/MM/yyyy' }}</td>
        </ng-container>

        <ng-container matColumnDef="opdNo">
          <th mat-header-cell *matHeaderCellDef>{{ 'LABEL.OPD_NO' | translate }}</th>
          <td mat-cell *matCellDef="let row">{{ row.opdNo }}</td>
        </ng-container>

        <ng-container matColumnDef="patientName">
          <th mat-header-cell *matHeaderCellDef>{{ 'LABEL.PATIENT_NAME' | translate }}</th>
          <td mat-cell *matCellDef="let row">
            <span class="f-w-600">{{ row.patientName }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="mobile">
          <th mat-header-cell *matHeaderCellDef>{{ 'LABEL.MOBILE_LABEL' | translate }}</th>
          <td mat-cell *matCellDef="let row">{{ row.mobile | defaultValue }}</td>
        </ng-container>

        <ng-container matColumnDef="address">
          <th mat-header-cell *matHeaderCellDef>{{ 'LABEL.ADDRESS_LABEL' | translate }}</th>
          <td mat-cell *matCellDef="let row">{{ row.address | defaultValue}}</td>
        </ng-container>

        <ng-container matColumnDef="diagnosis">
          <th mat-header-cell *matHeaderCellDef>{{ 'LABEL.DIAGNOSIS' | translate }}</th>
          <td mat-cell *matCellDef="let row">{{ row.diagnosis | defaultValue }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="cursor-pointer" (click)="viewOPD(row)">
        </tr>
      </table>

      @if (dataSource.filteredData.length === 0) {
      <div class="d-flex justify-content-center p-24">
        <p class="text-center f-s-20 f-w-700 m-t-20">{{'LABEL.NO_DATA' | translate}}</p>
      </div>
      }
    </div>
    }
    <mat-paginator class="paginator-fixed" [ngClass]="{'pointer-events-none': isLoading}"
      [pageSizeOptions]="pageSizeOptions" [showFirstLastButtons]="true" [pageSize]="10">
    </mat-paginator>
  </mat-card-content>
</mat-card>